import PerfectScrollbar from 'perfect-scrollbar';
import React, { useEffect, useRef } from 'react';
import { IWithChildren } from 'types';
import {
  ReactComponent as SvgScrollLeft,
} from 'public/assets/icons/scroll-left.svg';
import {
  ReactComponent as SvgScrollRight,
} from 'public/assets/icons/scroll-right.svg';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const AutoScroll = ({
  className, children, arrowClassName, innerClassName,
}:
IWithChildren & {
  className?: string,
  innerClassName?: string,
  arrowClassName?: string,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef?.current) {
      const ps = new PerfectScrollbar(containerRef?.current);
      const checkScroll = () => {
        ps.update();
        const hasScroll = (containerRef.current?.scrollWidth ?? 0) > (containerRef.current?.offsetWidth ?? 0);
        if (ps.reach.x === 'start' || !hasScroll) {
          containerRef.current?.parentElement?.classList.remove(styles.hasLeft);
        } else {
          containerRef.current?.parentElement?.classList.add(styles.hasLeft);
        }
        if (ps.reach.x === 'end' || !hasScroll) {
          containerRef.current?.parentElement?.classList.remove(styles.hasRight);
        } else {
          containerRef.current?.parentElement?.classList.add(styles.hasRight);
        }
      };
      window.addEventListener('resize', checkScroll);
      containerRef.current?.addEventListener('scroll', checkScroll);
      containerRef.current?.addEventListener('ps-scroll-x', checkScroll);

      checkScroll();

      return () => {
        window.removeEventListener('resize', checkScroll);
        containerRef.current?.removeEventListener('scroll', checkScroll);
        containerRef.current?.removeEventListener('ps-scroll-x', checkScroll);
        ps.destroy();
      };
    }
    return undefined;
  }, [containerRef?.current]);

  return (
    <div className={classNames(styles.outer, className)}>
      <div className={classNames(styles.scrollLeft, arrowClassName)}><SvgScrollLeft /></div>
      <div className={classNames(styles.scrollRight, arrowClassName)}><SvgScrollRight /></div>
      <div className={classNames(styles.inner, innerClassName)} ref={containerRef}>{children}</div>
    </div>
  );
};
